export const dateInputRegex = /[\d\/]/g
export const dateCharacters = '0123456789/'



// WEBPACK FOOTER //
// ./src/utils/constants.js